import React, { useCallback, useRef } from 'react';
import {
  Action,
  Actions,
  CloseIcon,
  DraggableDialog,
  AIIcon,
  Typography,
} from '@gogame/components';
import { useScreenState } from '@gogame/screens';

import { ExistingChat, NewChat, withChatProvider } from 'components/AIChatbot';
import { useCreateMessage, useLoadMessages, useIsUpdating } from './data';
import Message from './Message';

const AISmartSearchDialog = withChatProvider(({ onClose, onExited }) => {
  const ref = useRef(null);
  const isUpdating = useIsUpdating();
  const state = useScreenState();
  const handleClose = () => {
    onClose();
    onExited();
  };

  const [createMessage, { isLoading }] = useCreateMessage();

  const { isRefetching, data: messages, isFetched } = useLoadMessages();

  const handleSubmitMessage = useCallback(
    async ({ query }) => {
      await createMessage({ query, state });
    },
    [createMessage, state]
  );

  return (
    <DraggableDialog width={460} ref={ref}>
      <DraggableDialog.Toolbar
        icon={<AIIcon sx={{ color: 'text.icon' }} />}
        title={'Set up page content with AI'}
        primaryActions={
          <Actions>
            <Action
              tooltip={'Close'}
              size={'small'}
              icon={<CloseIcon size={'small'} />}
              onClick={handleClose}
            />
          </Actions>
        }
      />
      {messages.length || isUpdating ? (
        <ExistingChat
          isLoading={isLoading}
          isRefetching={isRefetching}
          isFetched={isFetched}
          messages={messages}
          onSubmitMessage={handleSubmitMessage}
          slots={{
            message: Message,
          }}
        />
      ) : (
        <NewChat isLoading={isLoading} onSubmitMessage={handleSubmitMessage}>
          <Typography variant={'h6'} color={'text.primary'} align={'center'}>
            Ask AI to set up page content
          </Typography>
        </NewChat>
      )}
    </DraggableDialog>
  );
});

export default AISmartSearchDialog;
